const alphaOnly = (e) => {
  const isAlphabet = /[а-яА-Яa-zA-z\s]/i.test(e.key);
  if (isAlphabet) return true;
  else e.preventDefault();
};

const numberOnly = (e) => {
  const isNumber = /^[0-9,]\d*$|^$/.test(e.key);
  const key = e.key;
  if (isNumber || key === "Backspace" || key === "Delete" || key === "Enter")
    return true;
  else e.preventDefault();
};

export { alphaOnly, numberOnly };
